/*
  HopMalta — Patch product-form.js v2
  Corrige "null is not an object" / "Cannot read properties of null"
*/

// 1. Intercepteur global — se lance immédiatement, avant tout
window.addEventListener('error', function(e) {
  if (e.message && (e.message.indexOf('setAttribute') !== -1 || e.message.indexOf('null is not an object') !== -1)) {
    if (e.filename && e.filename.indexOf('product-form') !== -1) {
      e.preventDefault();
      console.warn('[HopMalta] product-form error suppressed');
      return true;
    }
  }
}, true);

// 2. Patch DOM — attend que la page soit prête
function hopPatchForms() {
  try {
    var forms = document.querySelectorAll('product-form');
    forms.forEach(function(form) {
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn._hopPatched) {
        var orig = submitBtn.setAttribute.bind(submitBtn);
        submitBtn.setAttribute = function(name, value) {
          try { orig(name, value); } catch(e) {
            console.warn('[HopMalta] setAttribute intercepted');
          }
        };
        submitBtn._hopPatched = true;
      }
    });
  } catch(e) {
    console.warn('[HopMalta] patch forms error:', e.message);
  }
}

// Exécuter quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hopPatchForms);
} else {
  hopPatchForms();
}

// Observer les nouveaux formulaires ajoutés dynamiquement
document.addEventListener('DOMContentLoaded', function() {
  try {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.tagName === 'PRODUCT-FORM' || node.querySelector && node.querySelector('product-form')) {
              hopPatchForms();
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) {
    console.warn('[HopMalta] observer error:', e.message);
  }
});